import {createContext, RefObject} from 'react';
import {DatepickerHandle} from 'components/common/Datepicker';
import {PhoneInputHandle} from 'components/common/PhoneInput';
import {GUEST_FORM_NAMES} from '@chekin/core';
import type {
  InputFieldHandler,
  RegisteredFieldHandlers,
} from 'hooks/useVirtualKeyboard/types';

type DateFieldName =
  | typeof GUEST_FORM_NAMES.birth_date
  | typeof GUEST_FORM_NAMES.document_issue_date
  | typeof GUEST_FORM_NAMES.document_expiration_date;

type PhoneFieldName =
  | typeof GUEST_FORM_NAMES.phone
  | typeof GUEST_FORM_NAMES.second_phone;

type DatepickerRefsMap = Partial<Record<DateFieldName, RefObject<DatepickerHandle>>>;

type PhoneInputRefsMap = Partial<Record<PhoneFieldName, RefObject<PhoneInputHandle>>>;

type VirtualKeyboardContextType = {
  handleFocus: (fieldId: GUEST_FORM_NAMES | string) => void;
  handleBlur: (fieldId: GUEST_FORM_NAMES | string) => void;
  isKeyboardVisible: boolean;
  activeFieldId: string | null;
  datepickerRefs: DatepickerRefsMap;
  phoneInputRefs: PhoneInputRefsMap;
  countrySelectInputsRegister: (fieldId: string) => RegisteredFieldHandlers;
  locationSelectInputsRegister: (fieldId: string) => RegisteredFieldHandlers;
  registerCustomField: (fieldId: string, handlers: InputFieldHandler) => () => void;
};

const VirtualKeyboardContext = createContext<VirtualKeyboardContextType | undefined>(
  undefined,
);

export {VirtualKeyboardContext};
export type {
  VirtualKeyboardContextType,
  DatepickerRefsMap,
  DateFieldName,
  PhoneInputRefsMap,
  InputFieldHandler,
};
